"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.FilteredApptPurposes = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _banner = _interopRequireDefault(require("@kyruus/banner"));
var _PurposeOptions = require("../PurposeOptions");
var _ApptPurposeFilter = require("../ApptPurposeFilter");
var _styles = require("../styles");
const FilteredApptPurposes = _ref => {
  let {
    purposes: initialPurposes,
    animKey,
    labels: {
      noResultsLabel = 'No options match your selected criteria',
      ...restLabels
    } = {},
    onNameFilterChange,
    onVisitTypeFilterChange,
    onClearFilters,
    selectedPurpose,
    onSelect,
    virtualVisitConfig,
    ariaDescribedBy,
    legend,
    ...restProps
  } = _ref;
  const {
    isFiltered,
    filteredPurposes,
    nameFilterValue,
    visitTypeFilterValue,
    handleNameFilterChange,
    handleVisitTypeFilterChange,
    handleClearFilters
  } = (0, _ApptPurposeFilter.useApptPurposeFilter)({
    initialPurposes,
    /* eslint-disable-next-line react/display-name */
    highlightFn: (m, i) => /*#__PURE__*/_react.default.createElement("strong", {
      key: i
    }, m),
    onNameFilterChange,
    onVisitTypeFilterChange,
    onClearFilters
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ApptPurposeFilter.ApptPurposeFilter, (0, _extends2.default)({
    key: `${animKey}-appt-purpose-filter`,
    isFiltered: isFiltered,
    count: filteredPurposes.length,
    total: initialPurposes.length,
    nameFilterValue: nameFilterValue,
    visitTypeFilterValue: visitTypeFilterValue,
    onNameFilterChange: handleNameFilterChange,
    onVisitTypeFilterChange: handleVisitTypeFilterChange,
    onClearFilters: handleClearFilters,
    labels: restLabels
  }, restProps)), /*#__PURE__*/_react.default.createElement(_styles.ApptPurposeContainer, (0, _extends2.default)({}, restProps, {
    key: animKey,
    "aria-live": "polite"
  }), filteredPurposes.length > 0 && /*#__PURE__*/_react.default.createElement(_PurposeOptions.PurposeOptions, {
    selectedPurpose: selectedPurpose,
    purposes: filteredPurposes,
    onSelect: onSelect,
    virtualVisitConfig: virtualVisitConfig,
    ariaDescribedBy: ariaDescribedBy,
    legend: legend
  }), filteredPurposes.length === 0 && /*#__PURE__*/_react.default.createElement(_banner.default, {
    icon: "!",
    type: "warning",
    role: "alert"
  }, noResultsLabel)));
};
exports.FilteredApptPurposes = FilteredApptPurposes;
FilteredApptPurposes.propTypes = {
  purposes: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    name: _propTypes.string,
    visit_method: _propTypes.string,
    highlightedName: _propTypes.string
  })).isRequired,
  /* Internal key used for animation */
  animKey: _propTypes.string.isRequired,
  /* Labels for rendering the filter controls */
  labels: (0, _propTypes.shape)({
    noResultsLabel: _propTypes.string,
    purposeSearchLabel: _propTypes.string,
    purposeSearchPlaceholderLabel: _propTypes.string,
    visitTypeAllLabel: _propTypes.string,
    visitTypeInPersonLabel: _propTypes.string,
    visitTypeVirtualLabel: _propTypes.string
  }),
  /* Function executed when the name filter changes */
  onNameFilterChange: _propTypes.func,
  /* Function executed when the visit type filter changes */
  onVisitTypeFilterChange: _propTypes.func,
  /* Function executed when the filters are cleared */
  onClearFilters: _propTypes.func,
  /**
   * Set appointment purpose once fired 'onSelectPurpose' callback function
   */
  selectedPurpose: (0, _propTypes.shape)({
    name: _propTypes.string
  }),
  /**
   * callback function to select appointment purpose
   */
  onSelect: _propTypes.func.isRequired,
  /**
   * Label text to be display when virtual visit exists
   */
  virtualVisitConfig: (0, _propTypes.shape)({
    phone: _propTypes.string,
    video: _propTypes.string,
    in_person: _propTypes.string
  }).isRequired,
  ariaDescribedBy: _propTypes.string.isRequired,
  legend: _propTypes.string.isRequired
};
FilteredApptPurposes.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "FilteredApptPurposes",
  "props": {
    "labels": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "noResultsLabel": {
            "name": "string",
            "required": false
          },
          "purposeSearchLabel": {
            "name": "string",
            "required": false
          },
          "purposeSearchPlaceholderLabel": {
            "name": "string",
            "required": false
          },
          "visitTypeAllLabel": {
            "name": "string",
            "required": false
          },
          "visitTypeInPersonLabel": {
            "name": "string",
            "required": false
          },
          "visitTypeVirtualLabel": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "purposes": {
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "name": {
              "name": "string",
              "required": false
            },
            "visit_method": {
              "name": "string",
              "required": false
            },
            "highlightedName": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": true
    },
    "animKey": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "onNameFilterChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onVisitTypeFilterChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onClearFilters": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "selectedPurpose": {
      "description": "Set appointment purpose once fired 'onSelectPurpose' callback function",
      "type": {
        "name": "shape",
        "value": {
          "name": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "onSelect": {
      "description": "callback function to select appointment purpose",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "virtualVisitConfig": {
      "description": "Label text to be display when virtual visit exists",
      "type": {
        "name": "shape",
        "value": {
          "phone": {
            "name": "string",
            "required": false
          },
          "video": {
            "name": "string",
            "required": false
          },
          "in_person": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": true
    },
    "ariaDescribedBy": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "legend": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};